/**
* 左边菜单
*/ 
<template>
  <el-menu  default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" :text-color="color" background-color="rgba(220,38,38,0.0)"  active-text-color="#ffd04b">
    <div class="logobox flex-xy">
      <img  v-if="img" class="logoimg" :src="img" alt="">
      <img  v-else class="logoimg" src="../assets/pd.png" alt="">
      <div class="name" v-if="collapsed == false">{{StoresName}}</div>
      <div class="name" v-else>  </div>
    </div>
    <div v-for="menu in allmenu" :key="menu.menuid" >
      <el-menu-item v-if="(   menu.menus == null && menu.show == false || (menu.menus == null && isAdmin == 1))
       &&  !(iscdyy == 0 &&( menu.menuid == 16|| menu.menuid == 15 || menu.menuid == 18 ) ) 
       && !(ispaiban == 0 && menu.menuid == 41 )  
       && !(isYYDK == 0 && menu.menuid == 191 )  
       && !(ispaiban == 0 && menu.menuid == 71 ) 
       && !(ispaiban == 0 && menu.menuid == 21 ) 
       && !(iszjyy == 0 && menu.menuid == 31 ) 
       && !(IsPay== 0 && menu.menuid == 121 ) 
       && !(isqxsh== 0 && menu.menuid == 999  && isAdmin == 0 ) 

       
       && !(isCashier == 0 && menu.menuid == 141 ) 
       && !(isProject == 0 &&(menu.menuid == 21||menu.menuid == 31||menu.menuid == 41||menu.menuid == 61||menu.menuid == 71))"  :index="'/'+menu.url" @click="tochoose(menu)">
        <i :class="menu.icon"></i>   
        <span slot="title" v-if="!collapsed" >{{menu.menuname}}</span>
      </el-menu-item>
      <el-submenu v-if="((menu.menus != null && menu.show == false) || (menu.menus != null && isAdmin == 1))
      &&!(isGoods == 0 && menu.menuid == 9)
       && !(isyhq == 0 && IsActivity == 0 && menu.menuid == 171  ) "   :key="menu.menuid" :index="menu.menuname" >
        <template slot="title">
          <i :class="menu.icon"></i>
          <span style="font-size:15px;"  v-if="!collapsed">{{menu.menuname}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid" v-if="(chmenu.show == false || isAdmin == 1) && !(isCard == 0 && chmenu.menuid == 81) &&!(isdengji == 0 && chmenu.menuid == 86) &&!((isxynl == 0 && chmenu.menuid == 87) || IsHeadOffice==2) &&!(isyhq == 0 && chmenu.menuid == 1703) &&!(IsActivity == 0 && chmenu.menuid == 172) &&!(IsActivity == 0 && chmenu.menuid == 177) ">
            <span style="font-size:14px;">{{chmenu.menuname}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </div>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      css:1,
      collapsed: false,
      allmenu: [],
      isProject:'',
      isGoods:'',
      isCashier:'',
      IsActivity:'',
      isCard:'',
      HeadUrl:'',
      Limits:'',
      isAdmin:'',
      StoresName:'',
      IsPay:'',
      img:'',
      StoresType:'',
      name:'',
      nmae1:'',
      color:'#fff',
      ispaiban:'',
      iszjyy:'',
      WZYGName:'',
      WZHYName:'', 
      WZXMName:'', 
      WZPBName:'', 
      WZCDName:'',
      iscdyy:'',
      isYYDK:'',
      isjifen:'',
      isyhq:'',
      isdengji:'',
      isxynl:'',
      isqxsh:'',
      IsHeadOffice:'',
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
      this.isProject = localStorage.getItem('isProject')
      this.isGoods = localStorage.getItem('isGoods')
      this.isCashier = localStorage.getItem('isCashier')
      this.IsActivity = localStorage.getItem('IsActivity')
      this.isCard = localStorage.getItem('isCard')
      this.HeadUrl = localStorage.getItem('HeadUrllogo')
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.isAdmin = localStorage.getItem('isAdmin')
      this.IsPay = localStorage.getItem('IsPay')
      this.img = localStorage.getItem('HeadUrllogo')
      this.StoresName = localStorage.getItem('StoresName')
      this.StoresType = localStorage.getItem('StoresType')
      this.ispaiban = localStorage.getItem('ispaiban')
      this.iszjyy = localStorage.getItem('iszjyy')
      this.WZYGName = localStorage.getItem('WZYGName')
      this.WZHYName = localStorage.getItem('WZHYName') 
      this.WZXMName = localStorage.getItem('WZXMName') 
      this.WZPBName = localStorage.getItem('WZPBName') 
      this.WZCDName = localStorage.getItem('WZCDName') 
      this.iscdyy = localStorage.getItem('iscdyy') 
      this.isjifen = localStorage.getItem('isjifen')
      this.isyhq = localStorage.getItem('isyhq')
      this.isdengji = localStorage.getItem('isdengji')
      this.isxynl = localStorage.getItem('isxynl')
      this.IsHeadOffice = localStorage.getItem('IsHeadOffice')
      this.isYYDK = localStorage.getItem('isYYDK') 
      this.isqxsh = localStorage.getItem('isqxsh') 

      

      if(this.StoresType == 1){
          this.name = '签到'
           this.nmae1 = localStorage.getItem('zzjy') 
      }  else {
          this.name = '核销'
          this.nmae1 = localStorage.getItem('zzjy') 
      }   
      var res = {};  
if(this.isqxsh==1){
    res = {
      data: [
        {
          menuid: 1,
          icon: 'el-icon-house',
          menuname: '工作台',
          hasThird: null,
          url:'home/home',
          menus: null,
          show:true
        },
        {
          menuid: 21,
          icon: 'el-icon-search',
          menuname:this.name,
          hasThird: null,
          show:true,
           url: 'billboard/billboard',
          menus: null,

        }, {
          menuid: 191,
          icon: 'el-icon-printer',
          menuname:'打卡',
          hasThird: null,
          show:true,
           url: 'billboard/recordDK',
          menus: null,

        },
        
         {
          menuid: 31,
          icon: 'el-icon-notebook-1',
          menuname: this.nmae1,
          hasThird: null,
          show:true,
           url: 'board/board',
          menus: null,
  
        },
        {
          menuid:41,
          icon: 'el-icon-document',
          menuname: '预约情况',
          hasThird: null,
          show:true,
          url: 'appointment/appointment',
           menus: null,

         
        },
         {
          menuid:51,
          icon: 'el-icon-user',
          menuname: this.WZYGName,
          hasThird: null,
          url:'personnel/personnel',
          menus: null,
          show:true
        
       
        },  
        {
          menuid: 61,
          icon: 'el-icon-document-copy',
          menuname: this.WZXMName,
          hasThird: null,
          show:true,
          url: 'project/project',
          menus: null,
       
          
        },
        {
          menuid: 18,
          icon: 'el-icon-search',
          menuname: '预约详情',
          hasThird: null,
          show:true,
          url: 'site/siteMainList',
          menus: null,
       
          
        },
        {
          menuid: 999,
          icon: 'el-icon-search',
          menuname: '取消审核',
          hasThird: null,
          show:true,
          url: 'site/siteMainSHList',
          menus: null,
       
          
        },
        
        {
          menuid: 15,
          icon: 'el-icon-office-building',
          menuname: this.WZCDName,
          hasThird: null,
          show:true,
          url: 'site/siteList',
          menus: null,
       
          
        },
         {
          menuid: 16,
          icon: 'el-icon-office-building',
          menuname: this.WZCDName + '预约',
          hasThird: null,
          show:true,
          url: 'site/siteMain',
          menus: null,
       
          
        },
        
        {
          menuid:71,
          icon: 'el-icon-date',
          menuname: this.WZPBName,
          hasThird: null,
          url: 'arrange/arrange',
          show:true,
          menus: null,
        
        },
 
         {
          menuid: 8,
          icon: 'el-icon-s-custom',
          menuname: this.WZHYName,
          hasThird: null,
          url: null,
          show:true,
          menus: [
            {
              menuid: 81,
             
              menuname: '卡项',
              hasThird: 'N',
              url: 'card/card',
              menus: null,
                show:true,
            },
            {
              menuid: 82,
              icon: 'icon-order-manage',
              menuname: this.WZHYName,
              hasThird: 'N',
              url: 'vip/vip',
              menus: null,
              show:true,
            },
            {
              menuid: 83,
              icon: 'icon-order-manage',
              menuname: '意向' + this.WZHYName,
              hasThird: 'N',
              url: 'vip/customer',
              menus: null,
                show:true,
            },
             {
              menuid: 84,
              icon: 'icon-order-manage',
              menuname: '续期预警',
              hasThird: 'N',
              url: 'vip/renew',
              menus: null,
                show:true,
            },
             {
              menuid: 85,
              icon: 'icon-order-manage',
              menuname: '生日提醒',
              hasThird: 'N',
              url: 'vip/birthday',
              menus: null,
                show:true,
            },
            {
              menuid: 86,
              icon: 'icon-order-manage',
              menuname: this.WZHYName+ '等级',
              hasThird: 'N',
              url: 'vip/vipLevel',
              menus: null,
                show:true,
            },
            {
               menuid: 87,
              icon: 'icon-order-manage',
              menuname: '能力等级',
              hasThird: 'N',
              url: 'vip/vipCapacity',
              menus: null,
                show:true,

            }
          ]
        },
        {
          menuid: 9,
          icon: 'el-icon-present',
          menuname: '商品',
          hasThird: null,
          url: null,
          show:this.isGoods,
          menus: [
             {
              menuid: 91,
              icon: 'icon-order-manage',
              menuname: '类别',
              hasThird: 'N',
              url: 'shop/lay',
              menus: null,
                show:true,
            },
            {
              menuid: 95,
              icon: 'icon-order-manage',
              menuname: '商品管理',
              hasThird: 'N',
              url: 'shop/goods',
              menus: null,
              show:true,
            }
            
          ]
        },
        {
          menuid: 171,
          icon: 'el-icon-goods',
          menuname: '营销管理',
          hasThird: null,
          url: null,
          show:true,
          menus: [
            {
              menuid: 172,
             
              menuname: '秒杀活动',
              hasThird: 'N',
              url: 'marketing/SeckillAcinfo',
              menus: null,
                show:true,
            },
            {
              menuid: 177,
              icon: 'el-icon-shopping-bag-1',
              menuname: '拼团活动',
              hasThird: 'N',
              url: 'marketing/LadderSpellGroupAcinfo',
              menus: null,
              show:true,
            },
             {
              menuid:1703,
              icon: 'el-icon-s-ticket',
              menuname: '优惠券管理',
            hasThird: 'N',
              show:true,
              url: 'discoun/discoun', 
              menus: null,
            
            }   

          ]
        },
        
        {
          menuid:101,
          icon: 'el-icon-bell',
          menuname: '通知/公告',
          hasThird: null,
          show:true,
          url: 'notice/notice', 
          menus: null,
        
        },    
        {
          menuid: 111,
          icon: 'el-icon-edit-outline',
          menuname: '统计',
          hasThird: null,
          show:true,
          url: 'statistics/statistics', 
          menus: null,
         
        },
        {
          menuid: 141,
          icon: 'el-icon-shopping-bag-2',
          menuname: '收银订单',
          hasThird: null,
          show:true,
          url: 'Cashier/Cashier', 
          menus: null,
         
        },
        {
          menuid: 121,
          icon: 'el-icon-wallet',
          menuname: '财务',
          hasThird: null,
          url: 'finance/finance',
          show:true,
          menus: null,
        
        },
        {
          menuid: 131,
          icon: 'el-icon-setting',
          menuname: '设置',
          hasThird: null,
          url: 'setting/setting',
          show:true,
          menus: null,
        
        },
      ],
     
    }
}else{
    res = {
      data: [
        {
          menuid: 1,
          icon: 'el-icon-house',
          menuname: '工作台',
          hasThird: null,
          url:'home/home',
          menus: null,
          show:true
        },
        {
          menuid: 21,
          icon: 'el-icon-search',
          menuname:this.name,
          hasThird: null,
          show:true,
           url: 'billboard/billboard',
          menus: null,

        }, {
          menuid: 191,
          icon: 'el-icon-printer',
          menuname:'打卡',
          hasThird: null,
          show:true,
           url: 'billboard/recordDK',
          menus: null,

        },
        
         {
          menuid: 31,
          icon: 'el-icon-notebook-1',
          menuname: this.nmae1,
          hasThird: null,
          show:true,
           url: 'board/board',
          menus: null,
  
        },
        {
          menuid:41,
          icon: 'el-icon-document',
          menuname: '预约情况',
          hasThird: null,
          show:true,
          url: 'appointment/appointment',
           menus: null,

         
        },
         {
          menuid:51,
          icon: 'el-icon-user',
          menuname: this.WZYGName,
          hasThird: null,
          url:'personnel/personnel',
          menus: null,
          show:true
        
       
        },  
        {
          menuid: 61,
          icon: 'el-icon-document-copy',
          menuname: this.WZXMName,
          hasThird: null,
          show:true,
          url: 'project/project',
          menus: null,
       
          
        },
        {
          menuid: 18,
          icon: 'el-icon-search',
          menuname: '预约详情',
          hasThird: null,
          show:true,
          url: 'site/siteMainList',
          menus: null,
       
          
        },
       
        
        {
          menuid: 15,
          icon: 'el-icon-office-building',
          menuname: this.WZCDName,
          hasThird: null,
          show:true,
          url: 'site/siteList',
          menus: null,
       
          
        },
         {
          menuid: 16,
          icon: 'el-icon-office-building',
          menuname: this.WZCDName + '预约',
          hasThird: null,
          show:true,
          url: 'site/siteMain',
          menus: null,
       
          
        },
        
        {
          menuid:71,
          icon: 'el-icon-date',
          menuname: this.WZPBName,
          hasThird: null,
          url: 'arrange/arrange',
          show:true,
          menus: null,
        
        },
 
         {
          menuid: 8,
          icon: 'el-icon-s-custom',
          menuname: this.WZHYName,
          hasThird: null,
          url: null,
          show:true,
          menus: [
            {
              menuid: 81,
             
              menuname: '卡项',
              hasThird: 'N',
              url: 'card/card',
              menus: null,
                show:true,
            },
            {
              menuid: 82,
              icon: 'icon-order-manage',
              menuname: this.WZHYName,
              hasThird: 'N',
              url: 'vip/vip',
              menus: null,
              show:true,
            },
            {
              menuid: 83,
              icon: 'icon-order-manage',
              menuname: '意向' + this.WZHYName,
              hasThird: 'N',
              url: 'vip/customer',
              menus: null,
                show:true,
            },
             {
              menuid: 84,
              icon: 'icon-order-manage',
              menuname: '续期预警',
              hasThird: 'N',
              url: 'vip/renew',
              menus: null,
                show:true,
            },
             {
              menuid: 85,
              icon: 'icon-order-manage',
              menuname: '生日提醒',
              hasThird: 'N',
              url: 'vip/birthday',
              menus: null,
                show:true,
            },
            {
              menuid: 86,
              icon: 'icon-order-manage',
              menuname: this.WZHYName+ '等级',
              hasThird: 'N',
              url: 'vip/vipLevel',
              menus: null,
                show:true,
            },
            {
               menuid: 87,
              icon: 'icon-order-manage',
              menuname: '能力等级',
              hasThird: 'N',
              url: 'vip/vipCapacity',
              menus: null,
                show:true,

            }
          ]
        },
        {
          menuid: 9,
          icon: 'el-icon-present',
          menuname: '商品',
          hasThird: null,
          url: null,
          show:this.isGoods,
          menus: [
             {
              menuid: 91,
              icon: 'icon-order-manage',
              menuname: '类别',
              hasThird: 'N',
              url: 'shop/lay',
              menus: null,
                show:true,
            },
            {
              menuid: 95,
              icon: 'icon-order-manage',
              menuname: '商品管理',
              hasThird: 'N',
              url: 'shop/goods',
              menus: null,
              show:true,
            }
            
          ]
        },
        {
          menuid: 171,
          icon: 'el-icon-goods',
          menuname: '营销管理',
          hasThird: null,
          url: null,
          show:true,
          menus: [
            {
              menuid: 172,
             
              menuname: '秒杀活动',
              hasThird: 'N',
              url: 'marketing/SeckillAcinfo',
              menus: null,
                show:true,
            },
            {
              menuid: 177,
              icon: 'el-icon-shopping-bag-1',
              menuname: '拼团活动',
              hasThird: 'N',
              url: 'marketing/LadderSpellGroupAcinfo',
              menus: null,
              show:true,
            },
             {
              menuid:1703,
              icon: 'el-icon-s-ticket',
              menuname: '优惠券管理',
            hasThird: 'N',
              show:true,
              url: 'discoun/discoun', 
              menus: null,
            
            }   

          ]
        },
        
        {
          menuid:101,
          icon: 'el-icon-bell',
          menuname: '通知/公告',
          hasThird: null,
          show:true,
          url: 'notice/notice', 
          menus: null,
        
        },    
        {
          menuid: 111,
          icon: 'el-icon-edit-outline',
          menuname: '统计',
          hasThird: null,
          show:true,
          url: 'statistics/statistics', 
          menus: null,
         
        },
        {
          menuid: 141,
          icon: 'el-icon-shopping-bag-2',
          menuname: '收银订单',
          hasThird: null,
          show:true,
          url: 'Cashier/Cashier', 
          menus: null,
         
        },
        {
          menuid: 121,
          icon: 'el-icon-wallet',
          menuname: '财务',
          hasThird: null,
          url: 'finance/finance',
          show:true,
          menus: null,
        
        },
        {
          menuid: 131,
          icon: 'el-icon-setting',
          menuname: '设置',
          hasThird: null,
          url: 'setting/setting',
          show:true,
          menus: null,
        
        },
      ],
     
    }
}

   this.Limits.forEach(items => {
      res.data.forEach(item => { 
          if(item.menus == null){
              if(items == item.menuid)
              {
     
                 item.show = false
              }
               
          } else {
                item.menus.forEach(it => { 
                   
                      if(it.menuid == items){
                         it.show = false
                         item.show = false
                      }

                })
          }
      });
  });
   res.data.forEach(items => { 
      if(this.isProject == 0){
            if(items.menuid == 21){
              items.show = true
            }
            if(items.menuid == 31){
              items.show = true
            }
            if(items.menuid == 41){
              items.show = true
            }
            if(items.menuid == 61){
              items.show = true
            }
            if(items.menuid == 71){
              items.show = true
            }

      }
      

   })
    var res1 = {
      success: true,
      data: [
  
        {
          menuid: 141,
          icon: 'el-icon-shopping-cart-full',
          menuname: '前台收银',
          hasThird: null,
          url: 'machine/MachineConfig',
          menus:null,
          show:false,
          
        },
              
   
      ],
      msg: 'success'
    }

    this.allmenu = res.data
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
      if(this.collapsed == true){
           this.color = '#808080'
      } else {
         this.color = '#fff'
      
      }
        
        
    })
   this.$root.Bus.$on('act', value => {
     console.log(value)
     if(value == 1){
          this.allmenu =  res.data
          this.collapsed = false
           this.color = '#fff'
          this.$router.push({ path: '/home/home'})

      // this.res =  this.res
     } else {
     
          this.collapsed = true
          this.allmenu =  res1.data
            this.color = '#808080'
          this.$router.push({ path: '/machine/MachineConfig'})

     }
    
    })

  },
  methods:{
    tochoose(event){
      console.log("event",event)
      if(event.menuname == "监控大屏"){
        
        window.open(localStorage.getItem('openurl'))
      }

   

        // console.log('111')
    },
  },

}
</script>
<style>
.aside .el-submenu__icon-arrow{
  font-size: 0px !important;
}
.aside .el-menu{
  background-color:rgba(220,38,38,0.0)!important;
}
.aside .el-menu-item{
 background-color: rgba(220,38,38,0.0) !important;
}
.el-menu--vertical .el-menu-item-group ul .el-menu-item{
  background-color: white !important;
}
.el-menu--vertical .el-menu-item-group ul .el-menu-item:hover{
  background-color: rgb(231, 231, 231) !important;
}
.name{
  height: 20px;
  font-size: 16px;
  color: white;
  margin-top:5px;
  width: 100%;
  white-space: nowrap;
  text-overflow:ellipsis;
  overflow: hidden;
 
}
.el-menu-item{
  font-size: 16px;
}
.el-submenu .el-menu-item{
  min-width: 0px;
  
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  /* width: 160px; */
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 65px;
  width: 100%;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding-top:20px;
  padding-bottom:10px
}
.logoimg {
  height: 40px;
  width: 40px;
  border-radius: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue